// extracted by mini-css-extract-plugin
export default {"banner":"QK6iiFP","content":"Y4fNyxf","image":"GYU8t5N","textContainer":"Lr20E6D","headline":"hPHpmUJ","text":"S11_eDn"};